import { render, staticRenderFns } from "./customerSegmentEdit.vue?vue&type=template&id=191ded38"
import script from "./customerSegmentEdit.vue?vue&type=script&lang=js"
export * from "./customerSegmentEdit.vue?vue&type=script&lang=js"
import style0 from "./customerSegmentEdit.vue?vue&type=style&index=0&id=191ded38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports